import { HowItWorksSection } from "@/components/home/HowItWorksSection";
import { FinalCTA } from "@/components/home/FinalCTA";
import { useSeo } from "@/lib/seo";

export default function HowItWorks() {
    useSeo({ title: "How It Works — From Click to Growth in 4 Steps | SUDIGI", description: "Choose your service, checkout, talk to our BDE, and execution begins. See how Sudigi helps your business grow online." });
    return (<><div className="pt-8"><HowItWorksSection /></div><FinalCTA /></>);
}
